import React, { Component } from "react";
import { getEmail, getMobileNumber, getName } from "@10x/sso";
import { LocaleUtil } from "@eres/core";
import Strings from "@my-dld/assets/strings";
import { StringsWithPrefix } from "@my-dld/utils/Utils";
import { handleDataUpdate, IGreenListForm, IGreenListFormProps, IGreenListFormState } from "./Base";
import TextInputField from "../../Form/TextInputField";
import CheckBoxField from "../../Form/CheckBoxField";
import { isEmailAddress, normaliseMobileNumber } from "@eres/core/dist/StringUtils";
import { checkNonEmpty } from "@eres/ejari-web/utils";
import { ErrorContainerStateProvider } from "../../Form/FormField";

interface Props extends IGreenListFormProps {
	info?: ContactInfo;
}

export interface ContactInfo {
	email?: string,
	mobile?: string,
}

export interface Data extends ContactInfo {
	agree: boolean;
}

interface State extends Data, IGreenListFormState {
	errorContainer: { [ k: string ]: string };
	disclaimer: string;
	terms: string[];
}

class Terms extends Component<Props, State> implements IGreenListForm<Props, State> {
	constructor( props: Props ) {
		super( props );
		const name = LocaleUtil.getLocalValue( getName() );
		const info = props.info;
		this.state = {
			isValid: false,
			email: info?.email ?? getEmail(),
			mobile: info?.mobile ?? getMobileNumber(),
			agree: false,
			errorContainer: {},
			disclaimer: Strings.enable_green_list.replace( "~", name ),
			terms: StringsWithPrefix( "green_list_tc_" ),
		};
	}

	getData = ( state: State = this.state ) => {
		return {
			email: state.email,
			mobile: state.mobile,
			agree: state.agree,
		} as Data;
	};
	isValid = ( _isUserAction: boolean ) => {
		const state = this.state;
		const { email, mobile, agree } = state;
		const error: { [ k: string ]: string } = {};
		let isValid = true;

		isValid = checkNonEmpty( state, "email", error, isNonEmpty => {
			if ( isNonEmpty ) {
				isNonEmpty = isEmailAddress( email! );
				if ( !isNonEmpty ) {
					error.email = Strings.invalid_email;
				}
			}
			return isNonEmpty;
		} ) && isValid;
		isValid = checkNonEmpty( state, "mobile", error, isNonEmpty => {
			if ( isNonEmpty ) {
				const nm = normaliseMobileNumber( mobile! );
				isNonEmpty = nm.length === 12;
				if ( !isNonEmpty ) {
					error.mobile = Strings.invalid_mobile;
				}
			}
			return isNonEmpty;
		} ) && isValid;

		isValid = isValid && agree;
		if ( !isValid ) {
			error.agree = Strings.required;
		}
		this.setState( { errorContainer: error } );
		return isValid;
	};

	componentDidUpdate( prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any ) {
		const oldData = this.getData( prevState );
		const newData = this.getData( this.state );
		handleDataUpdate( oldData, newData, prevState, this );
	}

	render() {
		const { disclaimer, terms } = this.state;
		const formProps = {
			containerClassName: "form-group mb-4 field-style",
			inputClassName: "form-control",
			holder: this,
			errorProvider: ErrorContainerStateProvider,
		};
		return (
			<div className="terms-and-condition-list">
				{ disclaimer }
				<ol>
					{ terms.map( ( value, index ) => {
						return <li key={ index }>{ value }</li>;
					} ) }
				</ol>
				<hr/>
				<div className="row">
					<div className="col-md-6">
						<div className="form-group">
							<TextInputField
								{ ...formProps }
								placeHolder={ Strings.email_placeholder }
								id={ "email" }
								label={ Strings.email }
								required={ true }
								maxLength={ 256 }
								inputClassName="form-control ltr-text-field"
								onValueChange={ ( value, _extra ) => {
									this.setState( { email: value } );
								} }
							/>
						</div>
					</div>
					<div className="col-md-6">
						<div className="form-group">
							<TextInputField
								{ ...formProps }
								placeHolder={ Strings.mobile_placeholder }
								id={ "mobile" }
								label={ Strings.mobile_number }
								required={ true }
								maxLength={ 256 }
								inputClassName="form-control ltr-text-field"
								onValueChange={ ( value, _extra ) => {
									this.setState( { mobile: value } );
								} }
							/>
						</div>
					</div>
					<div className="col-md-12">
						<CheckBoxField
							id={ "agree" }
							holder={ this }
							required={ true }
							errorProvider={ ErrorContainerStateProvider }
							label={ Strings.i_agree_to + " " + Strings.terms_and_conditions }
							/>
					</div>
				</div>
			</div>
		);
	}
}

export default Terms;
